import { buildModelManager } from "../builder.js";
const DefaultQuickQaEmailCommandSelection = {
  __typename: true,
  id: true,
  confidence: true,
  conversationId: true,
  createdAt: true,
  disposition: true,
  error: true,
  internetMessageId: true,
  messageId: true,
  metadata: true,
  parsedCommand: true,
  qaChartId: true,
  quickChartEvaluationId: true,
  rawSnippet: { markdown: true, truncatedHTML: true },
  releaseRecipient: true,
  reviewerId: true,
  reviewerWorkspaceId: true,
  routeRecipient: true,
  savedComment: { markdown: true, truncatedHTML: true },
  senderEmail: true,
  senderName: true,
  status: true,
  uniqueKey: true,
  updatedAt: true
};
const modelApiIdentifier = "quickQaEmailCommand";
const pluralModelApiIdentifier = "quickQaEmailCommands";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultQuickQaEmailCommandSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultQuickQaEmailCommandSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQuickQaEmailCommandSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQuickQaEmailCommandSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQuickQaEmailCommandSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultQuickQaEmailCommandSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultQuickQaEmailCommandSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByUniqueKey",
    findByField: "uniqueKey",
    findByVariableName: "uniqueKey",
    modelApiIdentifier,
    defaultSelection: DefaultQuickQaEmailCommandSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByUniqueKey",
    findByField: "uniqueKey",
    findByVariableName: "uniqueKey",
    modelApiIdentifier,
    defaultSelection: DefaultQuickQaEmailCommandSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "quickQaEmailCommandGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const QuickQaEmailCommandManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultQuickQaEmailCommandSelection,
  operations
);
export {
  DefaultQuickQaEmailCommandSelection,
  QuickQaEmailCommandManager
};
//# sourceMappingURL=QuickQaEmailCommand.js.map
